'use client'

import { Header } from '@/components/marketplace/header'
import { PageViewTracker } from '@/components/page-view-tracker'
import { Toaster } from '@/components/ui/sonner'
import { CartProvider } from '@/contexts/cart'
import React from 'react'

export default function MarketplaceLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <CartProvider>
      <div className='min-h-screen bg-white'>
        <PageViewTracker />
        <Header />
        {children}
        <Toaster closeButton richColors />
      </div>
    </CartProvider>
  )
}
